import { render, staticRenderFns } from "./InwardFreightSeaFreightComponent.vue?vue&type=template&id=1295cd18"
import script from "./InwardFreightSeaFreightComponent.vue?vue&type=script&lang=js"
export * from "./InwardFreightSeaFreightComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports